import { useClearInferenceQueue } from "@rapid/store";
import { useCallback } from "react";
import api from "@rapid/utils/api";
import { useFlow } from "@rapid/contexts/FlowContext";
import { useIsGeneratingPredictions } from "./useIsGeneratingPredictions";
import { useMedia } from "@rapid/contexts/MediaContext";
import { InferenceTypes } from "@functions/rapid/services/inference/stream/types";

export const useStopGeneratingPredictions = () => {
    const { setFlowLocked } = useFlow();
    const isGeneratingPredictions = useIsGeneratingPredictions();
    const clearInferenceQueue = useClearInferenceQueue();
    const { mediaItems } = useMedia();

    const stopGeneratingPredictions = useCallback(() => {
        if (!isGeneratingPredictions) return;

        // Abort all active stream inferences (both SAM3 and OWLv2)
        for (const item of mediaItems) {
            const upload = item.uploadResizedResult || item.uploadResult;
            if (!upload?.filename) {
                throw new Error(`File ${item.file.name} not uploaded yet`);
            }

            // Abort both inference types since we may have parallel streams
            api.inference.abortStreamInfer(upload.filename, InferenceTypes.SAM3);
            api.inference.abortStreamInfer(upload.filename, InferenceTypes.OWLVIT);
        }

        clearInferenceQueue();
        setFlowLocked(false);
    }, [mediaItems, clearInferenceQueue, setFlowLocked, isGeneratingPredictions]);

    return { stopGeneratingPredictions };
};
